export default `
    --white-00: #FFFFFF; 
    --white-01: #F6F8FA; 
    --white-02: #F8F9FC; 
    --white-03: #F2F5F7; 
    --white-04: #EAEDF0;
    --white-05: #C0C5CF;

    --gray-00: #F6F7FB;
    --gray-01: #F4F4FD;
    --gray-02: #D6D8E6;
    --gray-03: #CAD0D1;
    --gray-04: #C3C3C3;
    --gray-05: #BCC1CB;
    --gray-06: #B2B3B7;
    --gray-07: #878787;
    --gray-08: #7C7F87;
    --gray-09: #62646B;
    --gray-10: #2D3A41;
    --gray-11: #32363A;
    --gray-12: #1D262A;
    --gray-13: #181F23;
    --gray-14: #0C1011;

    --slate-00: #FAFAFE; 
    --slate-01: #F5F6FC; 
    --slate-02: #F2F2F9; 
    --slate-03: #F0F1F6; 
    --slate-04: #EBF0F8; 
    --slate-05: #E7EDF5;
    --slate-06: #939AAA; 
    --slate-07: #787F8E; 
    --slate-08: #6B717E;
    --slate-09: #dbe2ed;

    --black-00: #212529;
    --black-01: #232323;
    --black-02: #000000;
    --black-03: #3E4048;
    --black-04: #3E4046;
    --black-05: #3A3D44;
    --black-06: #36393F;
    --black-07: #35393D;
    --black-08: #313338;
    --black-09: #33343A;
    --black-10: #2C2E33;
    --black-11: #262B2E;
    --black-12: #2A2B30;
    --black-13: #26292D;
    --black-14: #1B1F22;
    --black-15: #25282D;

    --blue-00: #F4FBFF;
    --blue-01: #ECF8FF;
    --blue-02: #E6F6FF;
    --blue-03: #C0DEE9;
    --blue-04: #E7F7FF;
    --blue-05: #C3EAFF;
    --blue-06: #93D4F6;
    --blue-07: #8FCDE5;
    --blue-08: #0494DA;
    --blue-09: #036B9E;
    --blue-10: #205B71;
    --blue-11: #14495D;
    --blue-12: #45B9F1;
    --blue-13: #495166;
    --blue-14: #1977a5;
    --blue-15: #313d57;
    --blue-16: #17b3ff;
    --blue-17: #5B6480;
    --blue-prime: #2087BD;
    --blue-transp: #44baf114;
    
    --purple-00: #E0E2EC;
    --purple-01: #B4C2E5;
    --purple-02: #7A83B4;
    --purple-03: #6F83B6;
    --purple-04: #6E7C9F;
    --purple-05: #384464;
    --purple-06: #323B4B;
    --purple-07: #2F3954;
    --purple-08: #273049;
    --purple-09: #151C2E;

    --green-00: #EEF8EA;
    --green-01: #69B150;
    --green-02: #50873C;
    --green-03: #74B85C;
    --green-04: #16d562;
    --green-prime: #519A38;
    --green-transp: #73b85c12;

    --red-00: #FFEFF1;
    --red-01: #DC3545;
    --red-02: #A71D2A;
    --red-03: #74131D;
    --red-04: #F67479;
    --red-05: #ffd7db;
    --red-06: #f8acaf;
    --red-07: #481319;
    --red-08: #66282f;
    --red-transp: #f674791c;

    --pink-00: #462834;
    --pink-01: #fff2f7;
    --pink-02: #FFCDE1;
    --pink-03: #C11F5E;
    --pink-04: #ff468e;

    --yellow-00: #FFFAEF;
    --yellow-01: #F0D6B8;
    --yellow-02: #FFB100;
    --yellow-03: #DD9A02;
    --yellow-04: #574a33;
    --yellow-05:  #70624b;
    --yellow-transp: #ffb1001c;

    --honey-00: #F7C879;
    --honey-01: #c4913c;
    --honey-02: #D98209;

    --orange-00: #FFF4EC;
    --orange-01: #F5853F;
    --orange-02: #D97232;

    --shadow-light-01: 4px 8px 9px -7px #2836821f; // containers-100
    --shadow-light-02: 1px 1px 4px 0 #102c492b;
    --shadow-light-03: 0px 0px 12px #a6b4c5;
    --shadow-light-04: 1px 1px 12px 1px #31323e94;
    --shadow-light-05: 1px 2px 6px 2px #5260bb57;
    --shadow-light-06:  1px 1px 2px 0px #111b5042,-3px -3px 4px -3px #0612577a;
    --shadow-light-07: 1px 1px 2px 0px #28368224, -4px -2px 0px -4px #2836822e;
    --shadow-light-08: -4px 0px 16px 0 #0019a21f;
    --shadow-light-10: 0 0 16px px #00000096;
    --shadow-light-11: 4px 8px 9px -7px #1729783b; // containers-200
    --shadow-light-12:  1px 1px 2px 0px #28368224, -2px -3px 6px -2px #2836822e;
    --shadow-light-13: 4px 0px 16px 0 #0019a21f;
    
    
    --shadow-dark-01: -1px -1px 1px 0px #00000014,  1px 1px 3px 0 #0000004d;
    --shadow-dark-02:  0 -1px 8px 1px var(--black-02);
    --shadow-dark-03:  0 0 8px 1px var(--black-02);
    --shadow-dark-04:  4px 8px 9px -7px #0000004f; // containers-100
    --shadow-dark-05:   4px 8px 9px -7px  #0000004d; // containers-200
    --shadow-dark-06:  0 0 24px -4px var(--black-02);
    --shadow-dark-07: 0px 0px 3px 0px black;
    --shadow-dark-08:  1px 1px 9px -2px #000000d6;
    --shadow-dark-09:  0px 0px 10px 0px #00000078;
    --shadow-dark-10:  0 0 24px -4px var(--black-02);

    --shadow-blue-01: 1px 1px 2px 0px #28368224, -4px -2px 0px -4px #084b6f;   
    --shadow-blue-02: -1px -1px 1px 0px #014c9114, 1px 1px 6px 1px #0059ac80;
    --shadow-blue-06: 1px 1px 6px 0 #0243846e;

    --shadow-danger-01: 1px 1px 6px 1px #f4dbdbde;
    --shadow-purple-01: 0 0 6px 1px #00000096;
    --shadow-purple-02: 1px 1px 8px 0 #04162787;


    --transp-red-00: #dc3545de;

`;
